export const CLEAR_COMPLETED_SHOPPING_LIST_INGREDIENTS = 'ClearCompletedShoppingListIngredientsAsync';
export const UPDATE_SHOPPING_LIST_INGREDIENT = 'UpdateShoppingListIngredientAsync';